module.exports = __webpack_public_path__ + "static/media/steps_kh_logo.2e436eed.png";